// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAppStoreAddOutlinedSvg from "@fishx/icons-svg/es/asn/PAppStoreAddOutlined";
import FishxIcon from '../components/FishxIcon';

var PAppStoreAddOutlined = function PAppStoreAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAppStoreAddOutlinedSvg
  }));
};

PAppStoreAddOutlined.displayName = 'PAppStoreAddOutlined';
export default React.forwardRef(PAppStoreAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAppStoreAddOutlined.js
// module id = 3208
// module chunks = 0